import React from 'react';

/**
 * CustomToast Component
 * A customizable toast content component with support for icons on both ends
 * 
 * @param {string} message - The toast message
 * @param {React.ReactNode} iconLeft - Icon/element to display on the left
 * @param {React.ReactNode} iconRight - Icon/element to display on the right
 * @param {string} title - Optional title above the message
 * @param {string} className - Additional CSS class names
 */
const CustomToast = ({ 
  message, 
  iconLeft, 
  iconRight, 
  title,
  className = ''
}) => {
  return (
    <div className={`gl-toast ${className}`}>
      {iconLeft && (
        <span className="gl-toast__icon gl-toast__icon--left">
          {iconLeft}
        </span>
      )}
      <div className="gl-toast__content">
        {title && <div className="gl-toast__title">{title}</div>}
        <div className="gl-toast__message">{message}</div>
      </div>
      {iconRight && (
        <span className="gl-toast__icon gl-toast__icon--right">
          {iconRight}
        </span>
      )}
    </div>
  );
};

export default CustomToast;

